import { mockHeadData } from 'utils/metaDataUtils/headData';
import { HeaderNav } from 'interfaces/navigation/Header';
import { PianoPageConfig } from 'services/Piano/entities/PianoPageConfig';
import { setMockPianoConfig } from 'services/Piano';
import { NextPage } from 'next/types';
import mockPageData from 'src/main/lib/mockData/page-data';
import { ArcSpanPageConfig } from 'services/ArcSpan/entities';
import { setarcSpanPageConfig } from 'services/ArcSpan';
import getFooter from 'api/Footer/getFooter';
import handleStaticPropsError from 'utils/handleStaticPropsError';
import getMenu from 'api/Header/getMenu';
import MyAccountLayout from 'components/MyAccountLayout';
import NewslettersPage from 'pages/Newsletters/NewslettersPage';
import { Newsletter } from 'interfaces/Account';
import getNewsletters from 'lib/personalizationApi/getNewsletters';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { safeAsync } from 'utils/errorHandlingUtils';
import fallback from 'lib/fallbackData/commonData';

interface NewslettersProps {
  newsletters: Newsletter[];
}

const NewslettersNextPage: NextPage<NewslettersProps> = ({ newsletters }: NewslettersProps) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_V3_KEY || ''}>
    <MyAccountLayout activeLink='/my-account/newsletters/'>
      <NewslettersPage newsletters={newsletters} />
    </MyAccountLayout>
  </GoogleReCaptchaProvider>
);

export default NewslettersNextPage;

export const getStaticProps = async () => {
  try {
    const newslettersHeadData = { ...mockHeadData };
    newslettersHeadData.title = 'My Account - Newsletters';
    const menu: HeaderNav = await safeAsync(
      () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_COM', 'own', null),
      fallback.headerNav,
    );
    const footer = await safeAsync(() => getFooter(), fallback.footer);
    const newsletters = await getNewsletters();

    const arcSpanPageConfig: ArcSpanPageConfig = setarcSpanPageConfig(mockPageData);
    const pianoPageConfig: PianoPageConfig = setMockPianoConfig();

    return {
      props: {
        arcSpanPageConfig,
        footer,
        headData: newslettersHeadData,
        headerNav: menu,
        newsletters,
        pianoPageConfig,
      },
      revalidate: 60,
    };
  } catch (e) {
    return handleStaticPropsError(e as Error);
  }
};
